//global 全局通用配置相关api
import request from '@/utils/request'

// 图片视频文件上传
export function UpdataFile(file) {
  return request({
    url: '/service-admin/admin/file/upload',
    method: 'post',
    data: file,
    // data,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  })
}

// 获取注册协议
export function Register() {
  return request({
    url: '/service-admin/admin/systemContent/findAll',
    method: 'post'
  })
}
// 更新注册协议
export function updataGlobalTExt(data) {
  console.log(data)
  return request({
    url: '/service-admin/admin/systemContent/updateSystemContent',
    method: 'post',
    data: data
  })
}
// 根据IDS获取多个用户信息
export function getUserInfos(data) {
  return request({
    url: '/service-member/memberCommon/findMemberInfoByIds',
    method: 'post',
    data: {
      ids: data
    }
  })
}
// 根据ID获取单个用户信息
export function getUserInfoByID(data) {
  return request({
    url: '/service-member/memberCommon/findMemberInfoById',
    method: 'post',
    data: {
      memberId: data
    }
  })
}
// 根据username获取单个用户信息
export function getUserInfoByUserName(data) {
  return request({
    url: '/service-member/memberCommon/findMemberInfoByUsername',
    method: 'post',
    data: {
      username: data
    }
  })
}
// 根据动态ID参看相关数据
export function findMemberInfoById(data) {
  return request({
    url: '/service-content/dynamicContentCommon/findMemberInfoByIds',
    method: 'post',
    data
  })
}
// 全部汽车品牌信息
export function getAllCarInfos() {
  return request({
    url: '/service-admin/common/findAllCar',
    method: 'post'
  })
}
// 获取全部礼物信息
export function getAllGiftInfos() {
  return request({
    url: '/service-admin/common/findAllGift',
    method: 'post'
  })
}
// 获取门槛礼物信息
export function getLimitGiftInfos() {
  return request({
    url: '/service-admin/common/findThresholdGift',
    method: 'post'
  })
}
// 获取全局参数
export function getGlobalParams() {
  return request({
    url: '/service-admin/common/findAllConfig',
    method: 'post'
  })
}
// 添加男性用户
export function addManMember(data) {
  return request({
    url: '/service-member/memberCommon/saveBoyMember',
    method: 'post',
    data: data
  })
}
// 添加女性用户
export function addWomanMember(data) {
  return request({
    url: '/service-member/memberCommon/saveGirlMember',
    method: 'post',
    data: data
  })
}
// 添加用户照片
export function addMemberPhoto(data) {
  return request({
    url: '/service-content/common/addMemberPhoto',
    method: 'post',
    data: data
  })
}
